import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import Modal from 'react-modal';
import { Provider } from 'react-redux';
import { ReactSVG } from 'react-svg';
import { ToastContainer } from 'react-toastify';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import AppRouter from 'Routes';
import { store } from 'Store';
import { STRIPE_PUBLIC_KEY } from 'Utils/constants';

import ToastIconClose from 'Assets/images/icons/toast-close-icon.svg';

const stripePromise = loadStripe(STRIPE_PUBLIC_KEY, { locale: 'en' });

const App = () => {
  useEffect(() => {
    Modal.setAppElement('#root');
  }, []);

  return (
    <Provider store={store}>
      <Helmet>
        <meta name="description" content="Web site created using create-react-app" />
        <title>Signaturely</title>
      </Helmet>
      <ToastContainer
        closeButton={({ closeToast }) => (
          <span onClick={closeToast} className="icons__toast-close-icon">
            <ReactSVG src={ToastIconClose} />
          </span>
        )}
        theme={'colored'}
        autoClose={6000}
        draggable
        draggablePercent={60}
        newestOnTop
      />
      <Elements stripe={stripePromise}>
        <AppRouter />
      </Elements>
    </Provider>
  );
};

export default App;
